import { render } from "./InterfaceTabBody.vue?vue&type=template&id=1ed3e094"
import script from "./InterfaceTabBody.vue?vue&type=script&lang=js"
export * from "./InterfaceTabBody.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__